/**
 * created by xcc
 *
 */
import React from 'react';
import UploadWall from "../../../../../../components/upload/UploadWall";
import _ from "lodash";
import {message, Button} from "antd";
import ChunkUpload from "../../../../../../components/upload/ChunkUpload";
import UploadItemLayout from "../../../../components/info/formItemTemplate/components/UploadItemLayout";
import {VIDEO_TYPE, AUDIO_TYPE} from "../../../../../../constants";
import BaseComponent from "../../../../../../base/BaseComponent";
import ImageView from "../../../../components/info/formItemTemplate/components/imgView";
import KkFileView from '../../formItemTemplate/components/kkFileView';

export default class Attachment extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            fileNumber: '',
            columns: [],
            maxFileList: window.sysConfigGetValueByKey("position.upload.max.fileList", "10") * 1,
            maxFileSize: window.sysConfigGetValueByKey("position.upload.max.fileSize", "100") * 1,
            kkFileViewVisible: false,
            path: {}
        };

        this.chunkUpload = new ChunkUpload({
            checkFileURL: "/storage/checkFile",
            checkChunkURL: "/storage/checkChunk",
            uploadChunkURL: "/storage/uploadChunk",
            chunkUploadOverURL: "/storage/chunkIsUploadOver",
            mergeChunksURL: "/storage/mergeChunk"
        });

        this.imageRef = React.createRef();
    }

    componentDidMount() {
        const observer = new ResizeObserver((e, o) => {
            this.setState({
                suffixWidth: e[0].contentRect.width + 5 + 32,  //添加间距
            })
        });
        const suffixDom = document.querySelector(`div[data-name ='${this.props.name}'] .rmt-input-suffix-layout`);
        if (suffixDom) {
            observer.observe(suffixDom);
        }
        this.updateValue();
    }

    // 更新组件内部value
    updateValue(refreshData) {
        if (refreshData) {
            const updateStack = {};
            for (const item of refreshData) {
                if (Object.keys(this.props.fieldProps).includes(item)) {
                    updateStack[item] = this.props.fieldProps[item];
                }
            }
            this.setState({...updateStack})
        } else {
            this.setState({
                value: this.props.fieldProps.value,
            })
        }
    }

    componentWillUnmount() {
        // 解决异常组件卸载调用setState
        this.setState = () => {
        }
    }

    static getDerivedStateFromProps(props, state) {
        // 判断props中的属性
        if (props.fieldProps && state !== props.fieldProps) {
            let newProps = {};
            for (const key in props) {
                if (!Object.hasOwnProperty.call(Attachment.defaultProps, key)) {
                    newProps[key] = props[key];
                }
            }
            for (const fieldKey in props.fieldProps) {
                if (Array.isArray(props.fieldProps?.extra) && !props.fieldProps?.extra.includes(fieldKey)) {
                    newProps[fieldKey] = props.fieldProps[fieldKey];
                }
            }
            return {...state, fieldProps: {...newProps}}
        }
        return state
    }

    fileType = [
        'jpg', 'jpeg', 'gif', 'png',
        'bmp', 'rm', 'rmvb', 'wmv',
        'avi', 'asf', 'mpg', 'mpeg',
        'flv', 'mp4', 'mov', 'mp3',
        'mp2', 'wav', 'mid', 'midi',
        'ra', 'doc', 'docx', 'ppt',
        'pptx', 'pps', 'ppsx', 'xls',
        'xlsx', 'pdf', 'eot', 'woff',
        'svg', 'ttf', 'otf', 'zip',
        'rar', 'swf', 'wps', 'dps',
        'et', 'apk'
    ];

    canInsertionFileExt = [
        {
            type: "pic",
            suffix: [...['jpg', 'jpeg', 'gif', 'png', 'bmp', "pdf", 'doc','docx'], ...['jpg', 'jpeg', 'gif', 'png', 'bmp', "pdf", 'doc','docx'].toUpperCase()],
            onInsertion: file => {
                this.getStorageFileByUrl(file.url)
                    .then(data => {

                    })
                    .catch(e => {
                        message.error("获取文件信息失败")
                    })
            }
        },
        {
            type: "video",
            suffix: VIDEO_TYPE,
            onInsertion: file => {
                this.getStorageFileByUrl(file.url)
                    .then(data => {

                    })
                    .catch(e => {
                        message.error("获取文件信息失败")
                    })
            }
        },
        {
            type: "audio",
            suffix: AUDIO_TYPE,
            onInsertion: file => {
                this.getStorageFileByUrl(file.url)
                    .then(data => {

                    })
                    .catch(e => {
                        message.error("获取文件信息失败")
                    })
            }
        }
    ]

    getStorageFileByUrl = url => new Promise((resolve, reject) => {
        this.request({
            url: `/storage/getStorageFileByUrl?url=${url}`,
            contentType: "json",
            callBack: data => {
                if (data && typeof data === "object") {
                    resolve(data)
                } else {
                    reject(data)
                }
            },
            errorCallBack: e => {
                reject(e)
                console.error(e)
            }
        })
    })

    onDownload = file => {
        if (file.url.indexOf("?") === -1) {
            window.location.href = file.url + "?download=1";
        } else {
            window.location.href = file.url + "&download=1";
        }
    };

    viewPic = (file) => {
        let suffix = file.name.split(".").at(-1);
        if (suffix === "pdf") {
            window.open(file.url);
        } else if (suffix === "doc" || suffix === "docx") {
            this.setState({
                path: file,
                kkFileViewVisible: true
            })
        } else {
            this.setState({
                path: file.url
            }, () => {
                this.imageRef.current.show();
            })
        }
    }

    render() {
        const {style = {}} = this.props.fieldProps;
        const {suffixWidth, value, fieldProps} = this.state;
        return (
            <>
                <div>
                    {value && value.length > 0 && <div style={{...style, flexGrow: 0}}>
                        <UploadWall
                            fieldProps={fieldProps}
                            customRequest={this.chunkUpload.start}
                            accept={"." + this.fileType.join(",.")}
                            multiple={true}
                            action="/storage/uploadFile"
                            listType={'list'}
                            fileList={value}
                            style={{padding: 'unset', height: (!value || value.length === 0) ? 60 : "100%"}}
                            uploadBtnName={
                                <div style={{display: "flex", flexFlow: "column"}}>
                                    <div>
                                        <span style={{marginLeft: 10}} onClick={(e) => {
                                            e.stopPropagation()
                                        }}>当前附件 {value?.length || 0} 个</span>
                                    </div>
                                </div>
                            }
                            beforeUpload={this.beforeUpload}
                            onDownload={this.onDownload}
                            showInsertion={file => {
                                try {
                                    let suffix = file.name.split(".").at(-1);
                                    let canInsertion = this.canInsertionFileExt.filter(item => item.type === "pic").find(item => item.suffix.some(item2 => item2 === suffix));
                                    if (canInsertion) {
                                        return <div onClick={() => {
                                            this.viewPic(file)
                                        }}>预览</div>
                                    } else {
                                        return ""
                                    }
                                } catch (e) {
                                    console.error(e)
                                    return ""
                                }
                            }}
                            fileItemComponent={UploadItemLayout}
                        />
                    </div>}
                </div>
                <ImageView ref={this.imageRef} path={this.state.path}/>
                <KkFileView onCancel={() => {
                    this.setState({
                        kkFileViewVisible: false,
                        path: {}
                    })
                }} visible={this.state.kkFileViewVisible} file={this.state.path}/>
                <style>
                    {
                        `div[data-name = '${this.props.name}'] .ant-form-item-children-icon {
                            left: calc(100% - ${suffixWidth > 0 ? suffixWidth : 35}px);
                        }`
                    }
                </style>
            </>
        )
    }

}